import * as React from 'react';
import { useNavigate, useParams } from "react-router-dom";
import configData from "../config.json";
import { GetSession, GetToken } from '../components/Session';
import { Form, Field, FormElement, FieldWrapper } from "@progress/kendo-react-form";
import { FormInput, FormSwitch, FormTextArea, FormNumericTextBox, FormDropDownList, FormDatePicker, FormAddress } from "../components/formComponents";
import { Button } from "@progress/kendo-react-buttons";
import { Grid, GridColumn as Column } from '@progress/kendo-react-grid';
import { Label, Error } from '@progress/kendo-react-labels';
import { filterBy } from "@progress/kendo-data-query";
import { DatePickerPropsContext } from '@progress/kendo-react-dateinputs';
import { getMultiSelectTreeValue } from "@progress/kendo-react-dropdowns";
import { processMultiSelectTreeData, expandedState  } from "../components/multiselecttree-data-operations";
import { MultiSelectTreeEditor } from "../components/MultiSelectTreeEditor";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import $ from "jquery"
import { TextBox } from '@progress/kendo-react-inputs';
import { GetPermissions } from '../components/Options';
import { AutoComplete } from "@progress/kendo-react-dropdowns";
import { Map, MapLayers, MapTileLayer, MapMarkerLayer } from '../components/Session';// from '@progress/kendo-react-map';
import { Dialog } from "@progress/kendo-react-dialogs";

export const FormGridEditContext = React.createContext({});

const DeleteCell = (props) => {
    const {dataItem} = props;
    return (
        <td>
          <Button icon="delete" onClick={() => props.remove(dataItem)} title="Delete" />
        </td>
      )
}

const FormGrid = fieldArrayRenderProps => {
    const [filter, setFilter] = React.useState([]);
    const { name } = fieldArrayRenderProps;
    const jpp = fieldArrayRenderProps.productList;
    const jobId = fieldArrayRenderProps.jobId;
    const UpdateGrid = fieldArrayRenderProps.update;
    const [editIndex, setEditIndex] = React.useState();

    const CommandCell = (props) => {
        return (
        <DeleteCell {...props} remove={Remove} />
        )
    }
    
    const datePickerProps = React.useCallback( // fix date format for filter and edit in grid
        (datePickerProps) => ({...datePickerProps, format: 'dd/MM/yy',  }), []
    );

    const [editID, setEditID] = React.useState(null);
    const rowClick = (event) => { setEditID(event.dataItem.Id);  };

    const itemChange = (event) => {
        const inEditID = event.dataItem.Id;
        const field = event.field || "";
        const newData = jpp.map((item) =>
        item.Id === inEditID
            ? {
                ...item,
                [field]: event.value,
            }
            : item
        );
        fieldArrayRenderProps.updated(newData);
        if (fieldArrayRenderProps.onChange) fieldArrayRenderProps.onChange.call(undefined, { value: newData });       
        UpdatePrice(event.dataItem, field, event.value);
    };

    const UpdatePrice = (item, field, value) => {
        var url = `${configData.SERVER_URL}apiv7/jobproductprices`;
        const init = {
            method: 'POST',
            accept: "application/json",
            headers: {
            "Content-type": "application/json",
            "Authorization": "Bearer " + GetToken()
            },
            mode: "cors",
            cache: "no-cache",
            body: JSON.stringify({
                "jobId": jobId,
                "productId": item.Id,
                "price" : field === "Price" ? value : item.Price,
                "tonnesOrdered": field === "Ordered" ? value: item.Ordered,
                "SchedulePriceDate": field === "SchedDate" ? value: item.SchedDate,
                "price_S": field === "SchedPrice" ? value: item.SchedPrice
            })
        }
        fetch(url, init).then(response => response).then(d => { 
        });        
    }

    // Save the changes
    const onSave = React.useCallback(() => {
      console.log(fieldArrayRenderProps);
      setEditIndex(undefined);
    }, [fieldArrayRenderProps]);
    
    const Remove = (item) => {
        if (fieldArrayRenderProps.onChange) fieldArrayRenderProps.onChange.call(undefined, { value: item });       
        var url = `${configData.SERVER_URL}apiv7/jobproductprices/${item.JppId}`;
        const init = {
            method: 'DELETE',
            accept: "application/json",
            headers: {
            "Content-type": "application/json",
            "Authorization": "Bearer " + GetToken()
            },
            mode: "cors",
            cache: "no-cache"
        }
        fetch(url, init).then(response => response).then(d => { 
           UpdateGrid();
        }); 
    }

    return <FormGridEditContext.Provider value={{ onSave, editIndex, parentField: name }}>
        <DatePickerPropsContext.Provider value={datePickerProps}>
            <Grid 
                pageable={{
                buttonCount: 4,
                pageSizes: [10, 20, 50, 100, 200, "All"],
                }}
                reorderable={true}
                resizable={true}
                data={filterBy(jpp, filter).map((item) => ({
                    ...item,
                    inEdit: item.Id === editID,
                    }))}
                editField="inEdit"
                onRowClick={rowClick}
                onItemChange={itemChange}
            >
                <Column field="Name" title="Product" editable={false}  />
                <Column field="Price" title="Price $" format="{0:c}" editor="numeric" filter="numeric" />
                <Column field="Ordered" title="Tonnes Ordered" format="{0:n2}" editor="numeric" filter="numeric" />
                <Column field="Processed" title="Tonnes Processed" format="{0:n2}" filter="numeric"  editable={false} />
                <Column field="SchedDate" title="Scheduled Date" format="{0:d/MM/yy}" editor="date" filter="date" />
                <Column field="SchedPrice" title="Scheduled Price $" format="{0:c}" filter="numeric" editor="numeric" />
                <Column field="Action" title="Delete" cell={CommandCell} editable={false}  />
            </Grid>
        </DatePickerPropsContext.Provider>          
    </FormGridEditContext.Provider>;
};
  
const EditJobs = () => {
    const { id } = useParams(); // editjobs/id url is used to edit existing job, otherwise id is undefined
    const saveName = id === undefined ? "Create" : "Update";
    const [formkey, setFormkey] = React.useState(0); // seems to be needed to push values to form after loading
    const [customers, setCustomers] = React.useState([]);
    const [customer, setCustomer] = React.useState("");
    const [customerOpen, setCustomerOpen] = React.useState(false);
    const [states, setStates] = React.useState([ ]);
    const [products, setProducts] = React.useState([]);
    const [product, setProduct] = React.useState("");
    const [productOpen, setProductOpen] = React.useState(false);
    const [addProducts, setAddProducts] = React.useState([]);
    const [addProduct, setAddProduct] = React.useState("");
    const [addProductOpen, setAddProductOpen] = React.useState(false);
    const [jpp, setJpp] = React.useState([]);
    const [selectedTab, setSelectedTab] = React.useState(0);
    const [permissions, setPermissions] = React.useState(null);
    const allOptions = React.useRef();
    const handleTabSelect = (e) => {setSelectedTab(e.selected); };
    const [centre, setCentre] = React.useState([-33.8, 151]);
    const tileUrl = e => `https://${e.subdomain}.tile.openstreetmap.org/${e.zoom}/${e.x}/${e.y}.png`;
    const [markers, setMarkers] = React.useState([]);
    const [zoom, setZoom] = React.useState(12);
    const [showMap, setShowMap] = React.useState(false);
    const navigate = useNavigate();
    if (localStorage.getItem("userid") === null) navigate("/logout");

    // default layout data for page
    const [layout, setLayout] = React.useState([
        { "field": "jobId", "label": "ID", "defaultValue": "", "isVisible": false, "type": "numeric" },
        { "field": "name", "label": "Name", "defaultValue": "", "isVisible": true, "type": "text" },
        { "field": "code", "label": "Code", "defaultValue": "", "isVisible": true, "type": "text" },
        { "field": "customerId", "label": "Customer", "defaultValue": "", "isVisible": true, "type": "list" },
        { "field": "productId", "label": "Product", "defaultValue": "", "isVisible": true, "type": "list" },
        { "field": "linkedProducts", "label": "Linked Products", "defaultValue": "", "isVisible": true, "type": "table" },
        { "field": "orderNumber", "label": "Order Number", "defaultValue": "", "isVisible": true, "type": "text" },
        { "field": "destinationId", "label": "Destination", "defaultValue": "", "isVisible": true, "type": "list" },
        { "field": "linkedDestinations", "label": "Linked Destinations", "defaultValue": "", "isVisible": true, "type": "table" },
        { "field": "sourceId", "label": "Source", "defaultValue": "", "isVisible": true, "type": "list" },
        { "field": "linkedSources", "label": "Linked Sources", "defaultValue": "", "isVisible": true, "type": "table" },
        { "field": "description", "label": "Comment", "defaultValue": "", "isVisible": true, "type": "text" },
        { "field": "department", "label": "Department", "defaultValue": "", "isVisible": true, "type": "text" },
        { "field": "workOrderSystemCode", "label": "Work Order System Code", "defaultValue": "", "isVisible": true, "type": "text" },
        { "field": "docketShouldBeSigned", "label": "Dockets must be signed", "defaultValue": "false", "isVisible": true, "type": "boolean" },
        { "field": "jobTonnesOrdered", "label": "Job Tonnes Ordered (t)", "defaultValue": 0, "isVisible": true, "type": "numeric" },
        { "field": "jobTonnesRunningTotal", "label": "Job Tonnage Running Total (t)", "defaultValue": 0, "isVisible": true, "type": "numeric" },
        { "field": "chargeDetails", "label": "Charge details", "defaultValue": "", "isVisible": true, "type": "heading" },
        { "field": "cartageCostPerTonne", "label": "Cartage Cost $/t", "defaultValue": 0, "isVisible": true, "type": "numeric" },
        { "field": "minimumCartage", "label": "Cartage Minimum $", "defaultValue": 0, "isVisible": true, "type": "numeric" },
        { "field": "overloadFee", "label": "Overload Charge $/t", "defaultValue": 0, "isVisible": true, "type": "numeric" },
        { "field": "cartagePerTonne", "label": "Cartage Charge $/t", "defaultValue": 0, "isVisible": true, "type": "numeric" },
        { "field": "addressDetails", "label": "Address details", "defaultValue": "", "isVisible": true, "type": "heading" },
        { "field": "jobAddress1", "label": "Job Address 1", "defaultValue": "", "isVisible": true, "type": "text" },
        { "field": "jobAddress2", "label": "Job Address 2", "defaultValue": "", "isVisible": true, "type": "text" },
        { "field": "jobSuburb", "label": "Job Suburb", "defaultValue": "", "isVisible": true, "type": "text" },
        { "field": "jobState", "label": "Job State", "defaultValue": "NSW", "isVisible": true, "type": "list" },
        { "field": "jobPostcode", "label": "Job Postcode", "defaultValue": "", "isVisible": true, "type": "text" },
        { "field": "jobZone", "label": "Job Zone", "defaultValue": "", "isVisible": true, "type": "text" },
        { "field": "jobPhone", "label": "Job Phone", "defaultValue": "", "isVisible": true, "type": "text" },
        { "field": "jobEmail", "label": "Job Email", "defaultValue": "", "isVisible": true, "type": "text" },
        { "field": "jobTrucks", "label": "Trucks", "defaultValue": "", "isVisible": true, "type": "list" },
        { "field": "addProduct", "label": "Product", "defaultValue": "", "isVisible": true, "type": "list" },
        { "field": "addPrice", "label": "Price $", "defaultValue": 0, "isVisible": true, "type": "numeric" },
        { "field": "addTonnesOrdered", "label": "Tonnes Ordered", "defaultValue": 0, "isVisible": true, "type": "numeric" },
        { "field": "jobDetails", "label": "Job", "defaultValue": "", "isVisible": true, "type": "heading" },
        { "field": "siteDetails", "label": "Site details", "defaultValue": "", "isVisible": true, "type": "heading" },
        { "field": "linkedData", "label": "Relationships", "defaultValue": "", "isVisible": true, "type": "heading" },
        { "field": "activeFrom", "label": "Active From", "defaultValue": undefined, "isVisible": true, "type": "datetime" },
        { "field": "activeTo", "label": "Active Until", "defaultValue": undefined, "isVisible": true, "type": "datetime" },
        { "field": "active", "label": "Active", "defaultValue": true, "isVisible": true, "type": "boolean"}
    ]);

    // Gets field from layout based on field name
    const GetField = (f, def = "") => {
        let fld = layout.find(obj => { return obj.field === f });
        if (fld === undefined) return { "field": f, "label": def, "defaultValue": "", "isVisible": true, "type": "text" }
        return fld;
    }

    // State data for form. Values match form value on submit
    const [values, setValues] = React.useState({
        jobId: GetField("jobId")["defaultValue"],
        name: GetField("name")["defaultValue"],
        code: GetField("code")["defaultValue"],
        customerId: GetField("customerId")["defaultValue"],
        productId: GetField("productId")["defaultValue"],
        linkedProducts: GetField("linkedProducts")["defaultValue"],
        orderNumber: GetField("orderNumber")["defaultValue"],
        destinationId: [],
        linkedDestinations: GetField("linkedDestinations")["defaultValue"],
        sourceId: [],
        linkedSources: GetField("linkedSources")["defaultValue"],
        description: GetField("description")["defaultValue"],
        department: GetField("department")["defaultValue"],
        workOrderSystemCode: GetField("workOrderSystemCode")["defaultValue"],
        docketShouldBeSigned: GetField("docketShouldBeSigned")["defaultValue"].toLowerCase() === "true",
        jobTonnesOrdered: GetField("jobTonnesOrdered")["defaultValue"],
        jobTonnesRunningTotal: GetField("jobTonnesRunningTotal")["defaultValue"],
        chargeDetails: GetField("chargeDetails")["defaultValue"],
        cartageCostPerTonne: GetField("cartageCostPerTonne")["defaultValue"],
        minimumCartage: GetField("minimumCartage")["defaultValue"],
        overloadFee: GetField("overloadFee")["defaultValue"],
        cartagePerTonne: GetField("cartagePerTonne")["defaultValue"],
        addressDetails: GetField("addressDetails")["defaultValue"],
        jobAddress1: GetField("jobAddress1")["defaultValue"],
        jobAddress2: GetField("jobAddress2")["defaultValue"],
        jobSuburb: GetField("jobSuburb")["defaultValue"],
        jobState: GetField("jobState")["defaultValue"],
        jobPostcode: GetField("jobPostcode")["defaultValue"],
        jobZone: GetField("jobZone")["defaultValue"],
        jobPhone: GetField("jobPhone")["defaultValue"],
        jobEmail: GetField("jobEmail")["defaultValue"],
        jobTrucks: [],
        jobSites: [],
        addProduct: [],
        addPrice: GetField("addProduct")["defaultValue"],
        addTonnesOrdered: GetField("addTonnesOrdered")["defaultValue"],
        siteDetails: GetField("siteDetails")["defaultValue"],        
        active: String(GetField("active")["defaultValue"]).toLowerCase() === "true",
        activeFrom: GetField("activeFrom")["defaultValue"],
        activeTo: GetField("activeTo")["defaultValue"]
      });

    // When page first loads:
    // - populate drop downs from apiv7/options
    // - if in edit mode, set initial values for all fields for apiv7/vehicleconfigurations
    React.useEffect(() => {
        GetPermissions(["ViewJob", "NewJob", "EditJob"], setPermissions);
        var url = configData.SERVER_URL + "apiv7/userinterfaces?$filter=viewName eq 'EditJobs'";
        const init = {
          method: 'GET',
          accept: 'application/json',
          headers: {"Authorization": "Bearer " + GetToken()}
        }
        fetch(url, init).then(response => response.json()).then(d => { 
            if (GetSession().IsMobile){
                let data = [];
                for(let i = 0; i < d.length; i++){
                    data.push({field: d[i].field, label: d[i].label, type:d[i].type, format: d[i].format, isVisible: d[i].isVisible && d[i].isVisibleOnMobile});
                }
                setLayout(data);
            } else {
                setLayout(d); 
            }
        });
        url = configData.SERVER_URL + "apiv7/options";
        fetch(url, init).then(response => response.json()).then(opt => {           
            allOptions.current = opt;
            setStates(opt.states);
            let cu = opt.customers.map(obj => { return obj.name; });
            setCustomers(cu);
            let pr = opt.products.map(obj => { return obj.name; });
            setProducts(pr);
            setAddProducts(pr);
            let defSrc = ConfigureSources(opt.sources, opt.inactiveSources, "1");
            let defDest = ConfigureDestinations(opt.destinations, opt.inactiveDestinations, "1");
            let allSites = GetList(opt.sites);
            let defSites = ConfigureSites(opt.sites, opt.inactiveSites, allSites);
            ConfigureTrucks(opt.trucks, opt.inactiveTrucks, "");
            if (id !== undefined){
                url = `${configData.SERVER_URL}apiv7/jobs/${id}`;
                fetch(url, init).then(response => response.json()).then(d => {
                    var cust = opt.customers.find(obj => { return obj.id === String(d.customerId) });
                    let dest = ConfigureDestinations(opt.destinations, opt.inactiveDestinations, d.destinationList);
                    let src = ConfigureSources(opt.sources, opt.inactiveSources, d.sourceList);
                    let sites = ConfigureSites(opt.sites, opt.inactiveSites, d.siteList);
                    let trucks = ConfigureTrucks(opt.trucks, opt.inactiveTrucks, d.truckList);
                    let prod = opt.products.find(obj => { return obj.id === String(d.productId) });
                    if (cust !== undefined) setCustomer(cust.name);
                    if (prod !== undefined) setProduct(prod.name);
                    setValues({
                        name: d.name === null ? "" : d.name,
                        code: d.code === null ? "" : d.code,
                        customerId: cust === undefined ? "" : cust.name,
                        productId: prod === undefined ? "" : prod.name,
                        orderNumber: d.orderNumber === null ? "" : d.orderNumber,
                        destinationId: dest,
                        sourceId: src,
                        description: d.description === null ? "" : d.description,
                        department: d.department === null ? "" : d.department,
                        workOrderSystemCode: d.workOrderSystemCode === null ? "" : d.workOrderSystemCode,
                        docketShouldBeSigned: d.docketsShouldBeSigned === null ? "" : d.docketsShouldBeSigned,
                        jobTonnesOrdered: d.jobTonnesOrdered === null ? "" : d.jobTonnesOrdered,
                        jobTonnesRunningTotal: d.jobTonnesRunningTotal === null ? "" : d.jobTonnesRunningTotal,
                        chargeDetails: d.chargeDetails === null ? "" : d.chargeDetails,
                        cartageCostPerTonne: d.cartageCostPerTonne === null ? "" : d.cartageCostPerTonne,
                        minimumCartage: d.minimumCartage === null ? "" : d.minimumCartage,
                        overloadFee: d.overloadFee === null ? "" : d.overLoadFee,
                        cartagePerTonne: d.cartagePerTonne === null ? "" : d.cartagePerTonne,
                        jobAddress1: d.jobAddress1 === null ? "" : d.jobAddress1,
                        jobAddress2: d.jobAddress2 === null ? "" : d.jobAddress2,
                        jobSuburb: d.jobSuburb === null ? "" : d.jobSuburb,
                        jobState: d.jobState === null ? "" : d.jobState,
                        jobPostcode: d.jobPostcode === null ? "" : d.jobPostcode,
                        jobZone: d.jobZone === null ? "" : d.jobZone,
                        jobPhone: d.jobPhone === null ? "" : d.jobPhone,
                        jobEmail: d.jobEmail === null ? "" : d.jobEmail,
                        jobSites: sites,
                        jobTrucks: trucks,
                        activeFrom: d.activeFrom === null ? undefined : new Date(d.activeFrom + "Z"),
                        activeTo: d.activeTo === null ? undefined : new Date(d.activeTo + "Z"),
                        active: d.isActive === null ? "" : d.isActive
                    });
                    UpdateJobProductPrices(opt.products, false);
                    setFormkey(formkey + 1);
                })
             } else {
                var v = {...values};
                v.jobSites = defSites;
                v.sourceId = defSrc;
                v.destinationId = defDest;
                setValues(v);                
                setFormkey(formkey + 1);
            }
        });
    }, [id]);

    const ConfigureProductPrices = (pp, refresh) => {
        let pl = [];
        let products = allOptions.current.products;
        if (pp !== null) {
            let totalOrdered = 0;
            let totalProcessed = 0;
            for (let i = 0; i < products.length; i++){
                let p = pp.find(obj => { return String(obj.productId) === products[i].id});
                if (p !== undefined){
                    let price = p !== undefined ? p.price : 0;
                    let ordered = p !== undefined ? p.tonnesOrdered: 0;
                    let processed = p !== undefined ? p.tonnesProcessed : 0;
                    totalOrdered += ordered;
                    totalProcessed += processed;
                    let schedDate = p !== undefined && p.schedulePriceDate !== null ? new Date(p.schedulePriceDate) : null;
                    let schedPrice = p !== undefined ? p.price_S: 0;
                    let jppId = p !== undefined ? p.jobProductPriceId: 0;
                    pl.push({ Id: products[i].id, Name: products[i].name, Price: price, Ordered: ordered, Processed: processed, SchedDate: schedDate, SchedPrice: schedPrice, JppId: jppId });
                }
            }
            if (refresh  && (totalOrdered !== values.jobTonnesOrdered || totalProcessed !== values.jobTonnesRunningTotal)) {
                let v = { ...values };
                v.jobTonnesOrdered = totalOrdered;
                v.jobTonnesRunningTotal = totalProcessed;
                setValues(v);
                setFormkey(new Date());
            }
        }
        setJpp(pl);
    }

    // Returns value to be sent to web api:
    // If field is visible just return f
    // If field is hidden, return defaultValue from layout data
    const GetDefaultData = (f, name) => {
        let fld = GetField(name);
        if (f === undefined) f = "";
        if (fld === undefined || fld === null) return f;
        let res = fld["defaultValue"];
        if (fld["isVisible"]) res = f;
        switch(fld["type"]){
            case "numeric": 
                res = parseFloat(res); 
                if (isNaN(res)) res = 0;
                break;
            case "boolean": res = (res === "true" || res === true); break;
            case "date":
                if (res === "") res = null;
                break;
            default: break;
        }
        return res;
    }

    // navigation
    const GoBack = () => Redirect("");
    const AddExtraCharge = () => navigate("/addextracharge/" + id);
    const Redirect = (msg = "") => {
        navigate("/jobs", {state: {msg: msg}});
    }

    if (permissions && !permissions.CanView) navigate("/error401");
    if (permissions && !permissions.CanEdit && id !== undefined) navigate("/error401");
    if (permissions && !permissions.CanCreate && id === undefined) navigate("/error401");

    const [sourcesData, setSourcesData] = React.useState([{id:0, text: "Active", items: []}]);
    const dataItemKey = "id";
    const checkField = "checkField";
    const checkIndeterminateField = "checkIndeterminateField";
    const subItemsField = "items";
    const expandField = "expanded";
    const fields = { dataItemKey, checkField, checkIndeterminateField, expandField, subItemsField };
    // state data for source multi-select tree   
    const [sourcesValue, setSourcesValue] = React.useState([]);
    const [sourceExpanded, setSourceExpanded] = React.useState([]);
    const onSourcesChange = (event) => {
        setSourcesValue(getMultiSelectTreeValue(sourcesData, {...fields, ...event, value: sourcesValue, }));
    }
    const sourcesTreeData = React.useMemo(() => processMultiSelectTreeData(sourcesData, { expanded: sourceExpanded, value: sourcesValue, ...fields }), [sourceExpanded, sourcesValue]);
    const ConfigureSources = (act, dis, sourceList) => {
        if (sourceList === null || sourceList === undefined) return [];
        let slsp = sourceList.split(',');
        let sl = [];
        let selected = [];
        for (let i = 0; i < act.length; i++){
            let entry = { text: act[i].name, id: act[i].id };
            sl.push(entry);
            let found = slsp.find(obj => { return obj === String(act[i].id) });
            if (found !== undefined) selected.push(entry);
        }
        let active = {id: 0, text: 'Active', items: sl };
        if (dis !== undefined && dis.length > 0){
            sl = [];
            for (let i = 0; i < dis.length; i++){
                let entry = { text: dis[i].name, id: dis[i].id };
                sl.push(entry);       
                let found = slsp.find(obj => { return obj === String(dis[i].id) });
                if (found !== undefined) selected.push(entry);
            }
            let inactive = {id: 999999, text: 'Inactive', items: sl };
            setSourcesData([active, inactive]);
        }
        else {
            setSourcesData([active]);
        }
        setSourcesValue([...selected]);       
        return [...selected];
    }

    // state data for destinations multi-select tree 
    const [destData, setDestData] = React.useState([{id:0, text: "Active", items: []}]);
    const [destValue, setDestValue] = React.useState([]);
    const [destExpanded, setDestExpanded] = React.useState([]);
    const destTreeData = React.useMemo(() => processMultiSelectTreeData(destData, { expanded: destExpanded, value:destValue, ...fields }), [destExpanded, destValue]);
    const ConfigureDestinations = (act, dis, destList) => {
        if (destList === null || destList === undefined) return [];
        let destsp = destList.split(',');
        let sl = [];
        let selected = [];
        for (let i = 0; i < act.length; i++){
            let entry = { text: act[i].name, id: act[i].id };
            sl.push(entry);
            let found = destsp.find(obj => { return obj === String(act[i].id) });
            if (found !== undefined) selected.push(entry);
        }
        let active = {id: 0, text: 'Active', items: [...sl] };
        if (dis !== undefined && dis.length > 0){
            sl = [];
            for (let i = 0; i < dis.length; i++){
                let entry = { text: dis[i].name, id: dis[i].id };
                sl.push(entry);       
                let found = destsp.find(obj => { return obj === String(dis[i].id) });
                if (found !== undefined) selected.push(entry);
                }
            let inactive = {id: 999999, text: 'Inactive', items: [...sl] };
            setDestData([active, inactive]);
        }
        else {
            setDestData([active]);
        }
        setDestValue([...selected]);
        return [...selected];
    }

    const [sitesData, setSitesData] = React.useState([{id:0, text: "Active", items: []}]);
    const [sitesValue, setSitesValue] = React.useState([]);
    const [siteExpanded, setSiteExpanded] = React.useState([]);
    const sitesTreeData = React.useMemo(() => processMultiSelectTreeData(sitesData, { expanded: siteExpanded, value: sitesValue, ...fields }), [siteExpanded, sitesValue]);
    const ConfigureSites = (act, dis, siteList) => {
        if (siteList === null || siteList === undefined) return [];
        let slsp = siteList.split(',');
        let sl = [];
        let selected = [];
        for (let i = 0; i < act.length; i++){
            let entry = { text: act[i].name, id: act[i].id };
            sl.push(entry);
            let found = slsp.find(obj => { return obj === String(act[i].id) });
            if (found !== undefined) selected.push(entry);
        }
        let active = {id: 0, text: 'Active', items: sl };
        if (dis !== undefined && dis.length > 0){
            sl = [];
            for (let i = 0; i < dis.length; i++){
                let entry = { text: dis[i].name, id: dis[i].id };
                sl.push(entry);       
                let found = slsp.find(obj => { return obj === String(dis[i].id) });
                if (found !== undefined) selected.push(entry);
            }
            let inactive = {id: 999999, text: 'Inactive', items: sl };
            setSitesData([active, inactive]);
        }
        else {
            setSitesData([active]);
        }
        setSitesValue([...selected]);       
        return [...selected];
    }

    const [trucksData, setTrucksData] = React.useState([{id:0, text: "Active", items: []}]);
    const [trucksValue, setTrucksValue] = React.useState([]);
    const [truckExpanded, setTruckExpanded] = React.useState([]);
    const trucksTreeData = React.useMemo(() => processMultiSelectTreeData(trucksData, { expanded: truckExpanded, value: trucksValue, ...fields }), [truckExpanded, trucksValue]);
    const ConfigureTrucks = (act, dis, truckList) => {
        if (truckList === null ||  truckList === undefined) return [];
        let slsp = truckList.split(',');
        let sl = [];
        let selected = [];
        for (let i = 0; i < act.length; i++){
            let entry = { text: act[i].name, id: act[i].id };
            sl.push(entry);
            let found = slsp.find(obj => { return obj === String(act[i].id) });
            if (found !== undefined) selected.push(entry);
        }
        let active = {id: 0, text: 'Active', items: sl };
        if (dis !== undefined && dis.length > 0){
            sl = [];
            for (let i = 0; i < dis.length; i++){
                let entry = { text: dis[i].name, id: dis[i].id };
                sl.push(entry);       
                let found = slsp.find(obj => { return obj === String(dis[i].id) });
                if (found !== undefined) selected.push(entry);
            }
            let inactive = {id: 999999, text: 'Inactive', items: sl };
            setTrucksData([active, inactive]);
        }
        else {
            setTrucksData([active]);
        }
        setTrucksValue([...selected]);       
        return [...selected];
    }

    const GetList = (obj) => {
        if (obj === undefined || obj === null || obj.length === 0) return "";
        var l = "";
        for (let i = 0; i < obj.length; i++){
            let id = obj[i].id;
            if (id !== 0 && id !== 999990){
                l += id;
                if (i < obj.length - 1) l += ",";
            }
        }
        return l;
    }

    function UpdatePrices(){  
        UpdateJobProductPrices(products, true);
    }

    const UpdateJobProductPrices = (products, refresh) => {
        let url = configData.SERVER_URL + "apiv7/jobproductprices?$filter=jobId eq " + id;
        const init = {
            method: 'GET',
            accept: 'application/json',
            headers: {"Authorization": "Bearer " + GetToken()}
          }
          fetch(url, init).then(response => response.json()).then(pp => {           
            ConfigureProductPrices(pp, refresh);
        });
    }

    const jppUpdated = (newData) => {
        setJpp(newData);
    };

    const addProductClicked = (e) => {
        e.preventDefault();       
        if (addProduct === undefined || addProduct === "") {
            alert("Select a product");
            return;
        }
        let p = allOptions.current.products.find(obj => obj.name === addProduct);
        let pr = parseFloat($("#addPrice").val().replace("$", ""));
        if (isNaN(pr)) pr = 0;
        let ton = parseFloat($("#addTonnesOrdered").val());
        if ((isNaN(ton))) ton = 0;
        var url = `${configData.SERVER_URL}apiv7/jobproductprices`;
        const init = {
            method: 'POST',
            accept: "application/json",
            headers: {
            "Content-type": "application/json",
            "Authorization": "Bearer " + GetToken()
            },
            mode: "cors",
            cache: "no-cache",
            body: JSON.stringify({
                "jobId": id,
                "productId": p.id,
                "price" : pr,
                "tonnesOrdered": ton
            })
        }
        fetch(url, init).then(response => response).then(d => { 
            UpdatePrices();
        });
    }

    const Validate = (dataItem) => {
        let st = "";
        if (dataItem.name === undefined || dataItem.name ==='') st += "Name\r\n";
        if (dataItem.code === undefined || dataItem.code ==='') st += "Code\r\n";
        if (customer === undefined || customer ==='') st += "Customer\r\n";
        if (st !== ""){
            setSelectedTab(0);
            alert("Please enter the following: \r\n" + st);
            return false;
        }
        return true;
    }

    // Handle submit button. For create POST the data, for edit PUT the data, then redirect to offenses index page.
    const handleSubmit = () => {
        let dataItem = { ...values };
        if (!Validate(dataItem)) return;  
        var cust = allOptions.current.customers.find(obj => obj.name === customer);
        if (cust === undefined) {
            setSelectedTab(0);
            alert("Please enter customer");
            return;
        }
        var prod = allOptions.current.products.find(obj => obj.name === product);
        if (prod === undefined) prod = { id: "1" };
        var pth = id === undefined ? "" : "/" + id;
        var siteList = GetList(dataItem.jobSites);
        var destList = GetList(dataItem.destinationId);
        var srcList = GetList(dataItem.sourceId);        
        var truckList = GetList(dataItem.jobTrucks); ;
        var jppList = [];
        for (let i = 0; i < jpp.length; i++){
            //if (jpp[i].Selected){
                jppList.push({jobId: id, productId: jpp[i].Id, price: jpp[i].Price, price_S: jpp[i].SchedPrice, tonnesOrdered:jpp[i].Ordered, schedulePriceDate:jpp[i].SchedDate });
           // }
        }
        var activeFrom = (dataItem.activeFrom === "" || dataItem.activeFrom === undefined) ? null : dataItem.activeFrom.toISOString();
        var activeTo = (dataItem.activeTo === "" || dataItem.activeTo === undefined) ? null : dataItem.activeTo.toISOString();
        //Price: price, Ordered: ordered, Processed: processed, SchedDate: schedDate, SchedPrice: schedPrice 
        var url = `${configData.SERVER_URL}apiv7/jobs${pth}`;
        const init = {
            method: id === undefined ? 'POST' : 'PUT',
            accept: "application/json",
            headers: {
            "Content-type": "application/json",
            "Authorization": "Bearer " + GetToken()
            },
            mode: "cors",
            cache: "no-cache",
            body: JSON.stringify({
            "jobId": id === undefined ? 0 : id,
            "name": GetDefaultData(dataItem.name, "name"),
            "code": GetDefaultData(dataItem.code, "code"),
            "customerId": GetDefaultData(cust.id, "customerId"),
            "productId": GetDefaultData(prod.id, "productId"),
            "orderNumber": GetDefaultData(dataItem.orderNumber, "orderNumber"),
            "description": GetDefaultData(dataItem.description, "description"),
            "department": GetDefaultData(dataItem.department, "department"),
            "workOrderSystemCode": GetDefaultData(dataItem.workOrderSystemCode, "workOrderSystemCode"),
            "docketsShouldBeSigned": GetDefaultData(dataItem.docketShouldBeSigned, "docketShouldBeSigned"),
            "jobTonnesOrdered": GetDefaultData(dataItem.jobTonnesOrdered, "jobTonnesOrdered"),
            "jobTonnesRunningTotal": GetDefaultData(dataItem.jobTonnesRunningTotal, "jobTonnesRunningTotal"),
            "chargeDetails": GetDefaultData(dataItem.chargeDetails, "chargeDetails"),
            "cartageCostPerTonne": GetDefaultData(dataItem.cartageCostPerTonne, "cartageCostPerTonne"),
            "minimumCartage": GetDefaultData(dataItem.minimumCartage, "minimumCartage"),
            "overloadFee": GetDefaultData(dataItem.overloadFee, "overloadFee"),
            "cartagePerTonne": GetDefaultData(dataItem.cartagePerTonne, "cartagePerTonne"),
            "jobAddress1": GetDefaultData(dataItem.jobAddress1, "jobAddress1"),
            "jobAddress2": GetDefaultData(dataItem.jobAddress2, "jobAddress2"),
            "jobSuburb": GetDefaultData(dataItem.jobSuburb, "jobSuburb"),
            "jobState": GetDefaultData(dataItem.jobState, "jobState"),
            "jobPostcode": GetDefaultData(dataItem.jobPostcode, "jobPostcode"),
            "jobZone": GetDefaultData(dataItem.jobZone, "jobZone"),
            "jobPhone": GetDefaultData(dataItem.jobPhone, "jobPhone"),
            "jobEmail": GetDefaultData(dataItem.jobEmail, "jobEmail"),
            "jobTrucks": GetDefaultData(dataItem.jobTrucks, "jobTrucks"),
            "siteList": siteList,
            "truckList": truckList,
            "sourceList": srcList,
            "destinationList": destList,
            "jobProductPrices": jppList,
            "activeFrom": activeFrom,
            "activeTo": activeTo,
            "isActive": GetDefaultData(dataItem.active, "active") 
            })
        }
        fetch(url, init).then(response => {
            if (response.status === 200) return response.json();
            var msg = id === undefined ? "New job created" : "Job updated";
            Redirect(msg);
        }).then(d => {
            if (id === undefined && d.jobId !== undefined) {
                navigate(`/editjobs/${d.jobId}`, { state: { msg: msg } });
            } else {
                var msg = id === undefined ? "New job created" : "Job updated";
                Redirect(msg);
            }
        });
    }   

    const CustomerChanged = (e) => {
        LookupCustomer(e.value);
        if (e.value === "") setCustomerOpen(true);
    }

    const LookupCustomer = (cust) => {
        setCustomer(cust);
        let c = cust.toLowerCase();
        let cu = [];
        allOptions.current.customers.map(obj => {
            if (c === "" || String(obj.name).toLowerCase().indexOf(c) >= 0) cu.push(obj.name);
            return null;
        });
        setCustomers(cu);
        let ci = allOptions.current.customers.find(obj => obj.name.toLowerCase() === c);
        if (ci !== undefined) {
            setCustomerOpen(false);
            let v = { ...values }; v.customerId = ci.id; setValues(v); 
        }
    }

    const ProductChanged = (e) => {
        LookupProduct(e.value);
        if (e.value === "") setProductOpen(true);
    }

    const LookupProduct = (prod) => {
        setProduct(prod);
        let p = prod.toLowerCase();
        let pr = [];
        allOptions.current.products.map(obj => {
            if (p === "" || String(obj.name).toLowerCase().indexOf(p) >= 0) pr.push(obj.name);
            return null;
        });
        setProducts(pr);
        let pi = allOptions.current.products.find(obj => obj.name.toLowerCase() === p);
        if (pi !== undefined) {
            setProductOpen(false);
            let v = { ...values }; v.productId = pi.id; setValues(v); 
        }
    }

    const AddProductChanged = (e) => {
        LookupAddProduct(e.value);
        if (e.value === "") setAddProductOpen(true);
    }

    const LookupAddProduct = (ap) => {
        setAddProduct(ap);
        let pr = [];
        allOptions.current.products.map(obj => {
            if (ap === "" || String(obj.name).toLowerCase().indexOf(ap) >= 0) pr.push(obj.name);
            return null;
        });
        setAddProducts(pr);
        let p = allOptions.current.products.find(obj => obj.name === ap);
        if (p !== undefined) {
            setAddProductOpen(false);
            let sp = p.data.split(',');
            if (sp.length > 2) {
                var v = { ...values };
                v.addPrice = parseFloat(sp[2]);
                v.addProduct = pr;
                setAddProductOpen(false);
                setValues(v);
                setFormkey(formkey + 1);
            }
        }
    }
    const OpenCustomer = () => {
        LookupCustomer("");
        setCustomerOpen(true);
    }
    const OpenProduct = () => {
        LookupProduct("");
        setProductOpen(true);
    }
    const OpenAddProduct = () => {
        LookupAddProduct("");
        setAddProductOpen(true);
    }

    const AddressChanged = (e) => {
        if (e !== null && e.value !== undefined && e.value.terms !== undefined && e.value.terms.length > 2) {
            let v = { ...values };
            v.jobAddress1 = e.value.structured_formatting.main_text;
            v.jobAddress2 = "";
            var ind = 1;
            if (e.value.terms.length > 3) ind = e.value.terms.length - 2;
            v.jobSuburb = e.value.terms[ind++].value;
            v.jobState = e.value.terms[ind].value;
            setValues(v);
            setFormkey(new Date());
        }
    }

    const DisplayMap = (e) => {
        let addr = values.jobAddress1;
        if (!values.jobAddress2 !== "") addr += "+" + values.jobAddress2;
        if (!values.jobSuburb !== "") addr += "+" + values.jobSuburb;
        if (!values.jobState !== "") addr += "+" + values.jobState;
        if (!values.jobPostcode !== "") addr += "+" + values.jobPostcode;
        addr += "+AU";
        let a = encodeURIComponent(addr);
        var url = `${configData.SERVER_URL}apiv7/private/getlocation?address=${a}`;
        const init = {
            method: 'GET',
            accept: "application/json",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Bearer " + GetToken()
            },
            mode: "cors",
            cache: "no-cache"
        }
        fetch(url, init).then(response => response.json()).then(l => {
            let m = [];
            setCentre([l.latitude, l.longitude]);
            m.push({ position: [l.latitude, l.longitude], name: values.address1 });
            setMarkers(m);
            setShowMap(true);
            setFormkey(formkey + 1);
        });
    }

    // This is annoying and should be unnecessary but Kendo really screws up the submit behaviour.
    // If JS changes anything and the form refreshes the isModified is lost. Easier just to maintain the data manually.
    const NameChanged = (e) => { let v = { ...values }; v.name = e.value; setValues(v); }
    const CodeChanged = (e) => { let v = { ...values }; v.code = e.value; setValues(v); }
    const ActiveChanged = (e) => { let v = { ...values }; v.active = e.value; setValues(v); }
    const OrderNumberChanged = (e) => { let v = { ...values }; v.orderNumber = e.value; setValues(v); }
    const DepartmentChanged = (e) => { let v = { ...values }; v.department = e.value; setValues(v); }
    const WorkOrderSystemCodeChanged = (e) => { let v = { ...values }; v.workOrderSystemCode = e.value; setValues(v); }
    const DescriptionChanged = (e) => { let v = { ...values }; v.description = e.value; setValues(v); }
    const ActiveFromChanged = (e) => { let v = { ...values }; v.activeFrom = e.value; setValues(v); }
    const ActiveToChanged = (e) => { let v = { ...values }; v.activeTo = e.value; setValues(v); }
    const DocketShouldBeSignedChanged = (e) => { let v = { ...values }; v.docketShouldBeSigned = e.value; setValues(v); }
    const CartagePerTonneChanged = (e) => { let v = { ...values }; v.cartagePerTonne = e.value; setValues(v); }
    const MinimumChargeChanged = (e) => { let v = { ...values }; v.minimumCartage = e.value; setValues(v); }
    const CartageCostPerTonneChanged = (e) => { let v = { ...values }; v.cartageCostPerTonne = e.value; setValues(v); }
    const OverloadFeeChanged = (e) => { let v = { ...values }; v.overloadFee = e.value; setValues(v); }
    const JobAddress2Changed = (e) => { let v = { ...values }; v.jobAddress2 = e.value; setValues(v); }
    const JobSuburbChanged = (e) => { let v = { ...values }; v.jobSuburb = e.value; setValues(v); }
    const JobStateChanged = (e) => { let v = { ...values }; v.jobState = e.value; setValues(v); }
    const JobPostcodeChanged = (e) => { let v = { ...values }; v.jobPostcode = e.value; setValues(v); }
    const JobZoneChanged = (e) => { let v = { ...values }; v.jobZone = e.value; setValues(v); }
    const JobPhoneChanged = (e) => { let v = { ...values }; v.jobPhone = e.value; setValues(v); }
    const JobEmailChanged = (e) => { let v = { ...values }; v.jobEmail = e.value; setValues(v); }
    const DestinationsChanged = (e) => { let v = { ...values }; v.destinationId = e.value; setValues(v); }
    const SourcesChanged = (e) => { let v = { ...values }; v.sourceId = e.value; setValues(v); }
    const TrucksChanged = (e) => { let v = { ...values }; v.jobTrucks = e.value; setValues(v); }
    const SitesChanged = (e) => { let v = { ...values }; v.jobSites = e.value; setValues(v); }

    // form validators
    const textValidator = (value) =>  !value ? "Please enter a value" : "";
    return (
        <div style={{padding: 20}}>
           <Form initialValues={values} key={formkey} render={(formRenderProps) => (
           <FormElement style={{width: "95%"}} >
                    <fieldset className={"k-form-fieldset"}>
                    <TabStrip selected={selectedTab} onSelect={handleTabSelect}>
                        {GetField("jobDetails")["isVisible"] && <TabStripTab title={GetField("jobDetails")["label"]}>
                        <div className="row">
                            {GetField("name")["isVisible"] && <div className="col-md-3">
                                        <Field id={"name"} name={"name"} label={GetField("name")["label"]} component={FormInput} validator={textValidator} onChange={NameChanged} />
                            </div>}
                            {GetField("code")["isVisible"] && <div className='col-md-3'>
                                <Field id={"code"} name={"code"} label={GetField("code")["label"]} component={FormInput} validator={textValidator} maxLength={40} onChange={CodeChanged} />
                            </div>}                            
                            {GetField("active")["isVisible"] && <div className='col-md-3'>
                                <Field id={"active"} name={"active"} label={GetField("active")["label"]} component={FormSwitch} onChange={ActiveChanged} />
                            </div>}                            
                        </div>
                        <div className="row">
                            {GetField("customerId")["isVisible"] && <div className='col-md-3'>
                                <FieldWrapper>
                                    <Label>{GetField("customerId")["label"]}</Label>
                                    <AutoComplete id={"customerId"} name={"customerId"} data={customers} value={customer} onChange={CustomerChanged} placeholder="Select Customer" opened={customerOpen} onFocus={OpenCustomer} onBlur={() => { setCustomerOpen(false) }} />     
                                </FieldWrapper>
                            </div>}
                            {GetField("productId")["isVisible"] && <div className='col-md-3'>
                                <FieldWrapper>
                                    <Label>{GetField("productId")["label"]}</Label>
                                    <AutoComplete id={"productId"} name={"productId"} component={AutoComplete} data={products} value={product} onChange={ProductChanged} placeholder="Select Product" opened={productOpen} onFocus={OpenProduct} onBlur={() => { setProductOpen(false) }} />
                                </FieldWrapper>
                            </div>}
                            {GetField("orderNumber")["isVisible"] && <div className="col-md-3">
                                <Field id={"orderNumber"} name={"orderNumber"} label={GetField("orderNumber")["label"]} component={FormInput} maxLength={40} onChange={OrderNumberChanged} />
                            </div>}
                        </div>
                        <div className='row' >
                            {GetField("department")["isVisible"] && <div className='col-md-3'>
                                <Field id={"department"} name={"department"} label={GetField("department")["label"]} component={FormInput} onChange={DepartmentChanged} />
                            </div>}                            
                            {GetField("workOrderSystemCode")["isVisible"] && <div className='col-md-3'>
                                <Field id={"workOrderSystemCode"} name={"workOrderSystemCode"} label={GetField("workOrderSystemCode")["label"]} component={FormInput} onChange={WorkOrderSystemCodeChanged} />
                            </div>}                            
                            {GetField("description")["isVisible"] && <div className="col-md-3">
                                <Field id={"description"} name={"description"} label={GetField("description")["label"]} component={FormTextArea} onChange={DescriptionChanged} />
                            </div>}
                        </div>
                        <div className="row">
                            {GetField("jobTonnesOrdered")["isVisible"] && <div className="col-md-3">
                                <Field id={"jobTonnesOrdered"} name={"jobTonnesOrdered"} label={GetField("jobTonnesOrdered")["label"]} disabled component={FormInput}/>
                            </div>}
                            {GetField("jobTonnesRunningTotal")["isVisible"] && <div className='col-md-3'>
                                <Field id={"jobTonnesRunningTotal"} name={"jobTonnesRunningTotal"} label={GetField("jobTonnesRunningTotal")["label"]} disabled component={FormInput}/>
                            </div>}                            
                            {GetField("docketShouldBeSigned")["isVisible"] && <div className='col-md-3'>
                                <Field id={"docketShouldBeSigned"} name={"docketShouldBeSigned"} label={GetField("docketShouldBeSigned")["label"]} component={FormSwitch} onChange={DocketShouldBeSignedChanged} />
                            </div>}                            
                            {id !== undefined && <div className='col-md-1' style={{paddingTop: 20}}>
                                <Button themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base" onClick={AddExtraCharge} >Add extra charge</Button>
                            </div>}
                        </div>
                        <div className="row">
                            {GetField("activeFrom")["isVisible"] && <div className="col-md-3">
                                <Field id={"activeFrom"} name={"activeFrom"} label={GetField("activeFrom")["label"]} component={FormDatePicker} onChange={ActiveFromChanged} />
                            </div>}
                            {GetField("activeTo")["isVisible"] && <div className='col-md-3'>
                                <Field id={"activeTo"} name={"activeTo"} label={GetField("activeTo")["label"]} component={FormDatePicker} onChange={ActiveToChanged } />
                            </div>}
                        </div>
                        </TabStripTab>}
                        {GetField("chargeDetails")["isVisible"] && <TabStripTab title={GetField("chargeDetails")["label"]}>
                        <div className='row' >
                            {GetField("cartagePerTonne")["isVisible"] && <div className='col-md-3'>
                                <Field id={"cartagePerTonne"} name={"cartagePerTonne"} label={GetField("cartagePerTonne")["label"]} component={FormNumericTextBox} min={0} max={100000} format="c2" onChange={CartagePerTonneChanged} />
                            </div>}
                            {GetField("minimumCartage")["isVisible"] && <div className='col-md-3'>
                                <Field id={"minimumCartage"} name={"minimumCartage"} label={GetField("minimumCartage")["label"]} component={FormNumericTextBox} min={0} max={100000} format="c2" onChange={MinimumChargeChanged} />
                            </div>}
                            {GetField("cartageCostPerTonne")["isVisible"] && <div className='col-md-3'>
                                <Field id={"cartageCostPerTonne"} name={"cartageCostPerTonne"} label={GetField("cartageCostPerTonne")["label"]} component={FormNumericTextBox} min={0} max={100000} format="c2" onChange={CartageCostPerTonneChanged } />
                            </div>}
                            {GetField("overloadFee")["isVisible"] && <div className='col-md-3'>
                                <Field id={"overloadFee"} name={"overloadFee"} label={GetField("overloadFee")["label"]} component={FormNumericTextBox} min={0} max={100000} format="c2" onChange={OverloadFeeChanged} />
                            </div>}
                        </div>
                        </TabStripTab>}
                        {GetField("addressDetails")["isVisible"] && <TabStripTab title={GetField("addressDetails")["label"]}>
                        <div className='row' >
                            {GetField("jobAddress1")["isVisible"] && <div className='col-md-3'>
                                <Field id={"jobAddress1"} name={"jobAddress1"} label={GetField("jobAddress1")["label"]} component={FormAddress} onChange={AddressChanged}  />
                            </div>}
                            {GetField("jobAddress2")["isVisible"] && <div className='col-md-3'>
                                <Field id={"jobAddress2"} name={"jobAddress2"} label={GetField("jobAddress2")["label"]} component={FormInput} onChange={JobAddress2Changed} />
                            </div>}
                            {GetField("jobSuburb")["isVisible"] && <div className='col-md-3'>
                                <Field id={"jobSuburb"} name={"jobSuburb"} label={GetField("jobSuburb")["label"]} component={FormInput} onChange={JobSuburbChanged} />
                            </div>}
                            {GetField("jobState")["isVisible"] && <div className='col-md-3'>
                                <Field id={"jobState"} name={"jobState"} label={GetField("jobState")["label"]} component={FormDropDownList} data={states} onChange={JobStateChanged} />
                            </div>}
                        </div>
                        <div className='row' >
                            {GetField("jobPostcode")["isVisible"] && <div className='col-md-3'>
                                <Field id={"jobPostcode"} name={"jobPostcode"} label={GetField("jobPostcode")["label"]} component={FormInput} onChange={JobPostcodeChanged} />
                            </div>}
                            {GetField("jobZone")["isVisible"] && <div className='col-md-3'>
                                <Field id={"jobZone"} name={"jobZone"} label={GetField("jobZone")["label"]} component={FormInput} onChange={JobZoneChanged} />
                            </div>}
                            {GetField("jobPhone")["isVisible"] && <div className='col-md-3'>
                                <Field id={"jobPhone"} name={"jobPhone"} label={GetField("jobPhone")["label"]} component={FormInput} onChange={JobPhoneChanged} />
                            </div>}
                            {GetField("jobEmail")["isVisible"] && <div className='col-md-3'>
                                <Field id={"jobEmail"} name={"jobEmail"} label={GetField("jobEmail")["label"]} component={FormInput} onChange={JobEmailChanged} />
                            </div>}
                        </div>
                        <div className='row' >
                            {false && GetField("showMap")["isVisible"] && <div className='col-md-3' style={{ paddingTop: "30px" }}>
                                <Button onClick={DisplayMap} >{GetField("showMap", "Show Map")["label"]}</Button>
                            </div>}
                        </div>
                        </TabStripTab>}
                        {GetField("linkedData")["isVisible"] && <TabStripTab title={GetField("linkedData")["label"]}>                                       
                        <div className='row' style={{ padding: "10px" }} >
                            {GetField("destinationId")["isVisible"] && <div className='col-md-4'>
                                {GetField("destinationId")["label"]}
                                <Field component={MultiSelectTreeEditor} name={"destinationId"} data={destTreeData} dataItemKey={dataItemKey} checkField={checkField} size="large" onChange={DestinationsChanged} />                                
                            </div>}
                            {GetField("sourceId")["isVisible"] && <div className='col-md-4'>
                                {GetField("sourceId")["label"]}
                                <Field component={MultiSelectTreeEditor} name={"sourceId"} data={sourcesTreeData} dataItemKey={dataItemKey} checkField={checkField} size="large" onChange={SourcesChanged} />                                
                            </div>}
                            {GetField("jobTrucks")["isVisible"] && <div className='col-md-4'>
                                {GetField("jobTrucks")["label"]}
                                <Field component={MultiSelectTreeEditor} name={"jobTrucks"} data={trucksTreeData} dataItemKey={dataItemKey} checkField={checkField} size="large" onChange={TrucksChanged} />
                            </div>}
                        </div>                                        
                        <div className='row' style={{ padding: "10px" }} >                           
                            {GetSession().SiteID && GetField("siteDetails")["isVisible"] && <div className='col-md-4'>
                                {GetField("siteDetails")["label"]}
                                <Field component={MultiSelectTreeEditor} name={"jobSites"} data={sitesTreeData} dataItemKey={dataItemKey} checkField={checkField} size="large" onChange={SitesChanged} />                                
                            </div>}
                        </div>
                        </TabStripTab>}
                        {GetField("productId")["isVisible"] && id !== undefined && <TabStripTab title={GetField("productId")["label"]}>
                        <div className='row' style={{paddingBottom: "20px"}} >
                            {GetField("addProduct")["isVisible"] && <div className='col-md-3'>
                                <FieldWrapper>
                                    <Label>{GetField("addProduct")["label"]}</Label>
                                            <AutoComplete id={"addProduct"} name={"addProduct"} data={addProducts} value={addProduct} onChange={AddProductChanged} placeholder="Select Product" opened={addProductOpen} onFocus={OpenAddProduct} onBlur={() => { setAddProductOpen(false) }} />
                                </FieldWrapper>
                            </div>}
                            {GetField("addPrice")["isVisible"] && <div className='col-md-3'>
                                <FieldWrapper>
                                    <Label>{GetField("addPrice")["label"]}</Label>
                                    <Field component={TextBox} id={"addPrice"} name={"addPrice"} type="number" min={0} max={100000} />
                                </FieldWrapper>
                            </div>}
                            {GetField("addTonnesOrdered")["isVisible"] && <div className='col-md-3'>
                                <FieldWrapper>
                                    <Label>{GetField("addTonnesOrdered")["label"]}</Label>
                                    <Field component={TextBox} id={"addTonnesOrdered"} name={"addTonnesOrdered"} type="number" min={0} max={100000} />
                                </FieldWrapper>
                            </div>}
                            <div className='col-md-1' style={{ paddingTop: "20px" }}>
                                <Button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base" themeColor={"primary"} onClick={addProductClicked}>Add Product</Button>
                            </div>
                        </div>
                        <div className='row' >
                            {GetField("productId")["isVisible"] && <div>
                            <FieldWrapper>
                                <Field name="productId" dataItemKey={"id"} component={FormGrid} productList={jpp} updated={jppUpdated} jobId={id} update={UpdatePrices} />
                            </FieldWrapper>
                            </div>}
                        </div>          
                        </TabStripTab>}
                        </TabStrip>                        
                    </fieldset>
                    <div className="k-form-buttons" style={{paddingTop: 10}}>
                        <div className='col-md-1'>
                            <Button themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base" onClick={handleSubmit}>{saveName}</Button>
                        </div>
                        <div className='col-md-1'>
                            <Button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base" onClick={GoBack}>Cancel</Button>
                        </div>
                    </div>                
                </FormElement>
            )} />
            {showMap && <Dialog title="Address Map" onClose={() => setShowMap(false)}>
                <div style={{ width: "1000px" }}>
                    <Map center={centre} zoom={zoom} minZoom={5}>
                        <MapLayers>
                            <MapTileLayer urlTemplate={tileUrl} />
                            <MapMarkerLayer data={markers} locationField="position" titleField="name" />
                        </MapLayers>
                    </Map>
                </div>
            </Dialog>}
        </div>
    );
}

export default EditJobs